module.exports = __webpack_public_path__ + "img/Logo-Morado.a5d7f216.svg";